import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["src", "alt"]

import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';

interface Image {
  url: string;
  focalPoint: { x: number; y: number } | null;
  public: boolean;
}

const minSwipeDistance = 50;


export default /*#__PURE__*/_defineComponent({
  __name: 'Lightbox',
  props: {
    images: {},
    visible: { type: Boolean },
    currentIndex: {}
  },
  emits: ["close", "next", "prev"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;


const currentIndex = computed(() => props.currentIndex);
const currentImg = computed(() => props.images[currentIndex.value]);

const hasPrev = computed(() => currentIndex.value > 0);
const hasNext = computed(() => currentIndex.value < props.images.length - 1);

const close = () => {
  emit('close');
};

const nextImage = () => {
  if (hasNext.value) {
    emit('next');
  }
};

const prevImage = () => {
  if (hasPrev.value) {
    emit('prev');
  }
};


//Swipi Snipi Handling
const touchStartX = ref<number | null>(null);
const touchEndX = ref<number | null>(null);
const onTouchStart = (e: TouchEvent) => {
  touchStartX.value = e.changedTouches[0].screenX;
};

const onTouchEnd = (e: TouchEvent) => {
  touchEndX.value = e.changedTouches[0].screenX;
  handleSwipe();
};

const handleSwipe = () => {
  if (!touchStartX.value || !touchEndX.value) return;
  const distance = touchStartX.value - touchEndX.value;
  if (Math.abs(distance) > minSwipeDistance) {
    if (distance > 0 && hasNext.value) {
      emit('next');
    } else if (distance < 0 && hasPrev.value) {
      emit('prev');
    }
  }
  touchStartX.value = null;
  touchEndX.value = null;
}

const onKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    emit('close');
  }
}

onMounted(() => {
  window.addEventListener('keydown', onKeydown);
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown);
})

onMounted(() => {
  if (props.visible) {
    document.body.style.overflow = 'hidden';
  }
})

watch(() => props.visible, (newVal) => {
  if (newVal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
})


return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50",
        onClick: _withModifiers(close, ["self"]),
        onKeydown: _withKeys(close, ["esc"]),
        tabindex: "0"
      }, [
        _createElementVNode("div", {
          class: "relative max-w-4xl w-full mx-4",
          onTouchstart: onTouchStart,
          onTouchend: onTouchEnd
        }, [
          _createElementVNode("button", {
            class: "absolute top-2 right-4 text-white focus:outline-none text-[40px]",
            onClick: close,
            "aria-label": "Close"
          }, " × "),
          _createElementVNode("img", {
            src: currentImg.value.url,
            alt: `Image ${currentIndex.value + 1}`,
            class: "rounded-md w-full h-auto"
          }, null, 8, _hoisted_1),
          (hasPrev.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "absolute top-1/2 left-0 transform -translate-y-1/2 text-white text-4xl px-4 focus:outline-none",
                onClick: prevImage,
                "aria-label": "Previous Image"
              }, " ❮ "))
            : _createCommentVNode("", true),
          (hasNext.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "absolute top-1/2 right-0 transform -translate-y-1/2 text-white text-4xl px-4 focus:outline-none",
                onClick: nextImage,
                "aria-label": "Next Image"
              }, " ❯ "))
            : _createCommentVNode("", true)
        ], 32)
      ], 32))
    : _createCommentVNode("", true)
}
}

})